import { NEXT_STEP_LABEL_STORAGE_KEY } from 'utils/constants'

export const storeNextStepLabel = (nextStepLabel: string | null): void => {
    const trimmed = nextStepLabel?.trim()
    if (trimmed) {
        sessionStorage.setItem(NEXT_STEP_LABEL_STORAGE_KEY, trimmed)
    } else {
        sessionStorage.removeItem(NEXT_STEP_LABEL_STORAGE_KEY)
    }
}
